import React from 'react';
import {
    TextInput,
    DateInput,
    Create,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    Notification,
    SimpleForm,
} from 'react-admin';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import FormUnc  from '../controls/FormUcn';
import ErrorBoundary from '../ErrorBoundary';

const editStyles = {
    root: { alignItems: 'flex-start' },
};

const shippingReady = [
    {
            id : 'Y',
            name: 'Yes'
    },
    {
            id: 'N',
            name: 'No'
    }
]

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const PackingEditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath}  label='Packing List'/>
    </CardActions>
);


const PackingToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

const PackingCreate = props => (
 <ErrorBoundary>  
<Create title='Create Packing' {...props}  actions={<PackingEditActions/>} >
    <SimpleForm  toolbar={<PackingToolbar />}> 
        <Table  style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }} >
            <TableBody >                 
                <TableRow >
                    <TableCell align="left">Case Number<br/><TextInput source="case_no" label="" validate={required()}/></TableCell>
                    <TableCell align="left" id="td_pkdate">Packing Date<br/><DateInput source="packing_date" label="" validate={required()}/></TableCell>
                </TableRow>
                <FormUnc />
                
            </TableBody>
        </Table>    
    </SimpleForm>

</Create>
</ErrorBoundary>  
);
export default PackingCreate ;
